<template>
  <Overlay :show="isLoading" rounded="sm" class="color-green-main overlay-small">
    <div class="search-map" v-click-outside="onClickOutside">
      <div class="input-group input-group-sm">
        <input type="text" class="form-control" placeholder="Digite aqui a sua pesquisa"
          autofocus v-model="term" @focus="setHotkeys(true)" @blur="setHotkeys(false)" @keyup="handleKeyUp">
        <div class="input-group-append">
          <button class="btn btn-light" type="button" @click.prevent="clear" title="Limpar o texto da consulta"><i class="fa fa-times"
              aria-hidden="true"></i></button>
        </div>
      </div>

      <!-- <div class="input-group">
        <input type="text" class="form-control form-control-sm search-input" placeholder="Digite aqui a sua pesquisa"
          autofocus v-model="term" @focus="setHotkeys(true)" @blur="setHotkeys(false)" @keyup="handleKeyUp" />
        <div class="input-group-append">
          <button class="btn btn-sm btn-light clear-button" @click.prevent="clear" title="Limpar o texto da consulta">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </div> -->

      <div class="search-autocomplete" v-show="showResults">
        <div class="card border-0 shadow-sm">
          <small v-if="searchResult.length >= 10" class="d-block text-center py-2 mb-0" style="color: #cc9900;">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            Alguns resultados podem não ter sido exibidos. Experimente refinar sua busca.
          </small>

          <ul class="list-group list-group-flush">
            <li class="list-group-item py-1 search-item" v-for="(item, index) in searchResult" :key="index" @click.stop>
              <div class="row">
                <div class="col-10" @click.stop="selectAddress(item)">
                  <span class="align-middle">
                    {{ item.name }} - {{ item.folderName }}
                    <br />
                    <small v-if="item.condominiumId" class="text-muted">
                      {{ "Condomínio: " + item.condominiumName }}
                    </small>
                  </span>
                </div>
                <div class="col-2">
                  <div class="btn-group float-right">
                    <button v-if="!item.type" class="btn btn-light btn-sm action-button"
                      v-has-permission.permission="['CLI', 'CA']" title="Salvar prospect de acordo com o endereço"
                      @click.stop="selectClient(item)">
                      <img src="../../../assets/img/map/user_outline.png" />
                    </button>
                    <button class="btn btn-light btn-sm action-button" title="Verificar viabilidade para o endereço"
                      @click.stop="viability(item)" v-has-permission.permission="['AVA', 'VI']">
                      <i class="fa fa-crosshairs"></i>
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Overlay>
</template>

<script>
import GoogleService from "../../../components/extra/GoogleService";
import storage from "../../../components/extra/LocalStorage";
import debounce from "../../../components/extra/Debounce";
import Request from "../../../request/request";
import { searchEquipmentByName } from "../../../router/ApiPaths";
import { sendMapAction, centerMapPoint } from "../../../components/MessageBus";
import { openSubPopup, openPopupMap } from "../popup/index";
import store from "../../../store";
import Overlay from "../../../components/extra/Overlay.vue";

export default {
  name: "SearchBar",
  components: {
    Overlay,
  },
  mixins: [GoogleService, Request],
  directives: {
    clickOutside: {
      bind(el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('mousedown', el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener('mousedown', el.clickOutsideEvent);
      },
    },
  },
  data() {
    return {
      term: "",
      searchResult: [],
      showResults: false,
      isLoading: false,
    };
  },
  watch: {
    term: debounce(function () {
      this.findByText();
    }, 1000),
    searchResult(newVal) {
      this.showResults = newVal.length > 0;
    }
  },
  methods: {
    onClickOutside() {
      this.showResults = false;
    },
    findByText() {
      this.isLoading = true
      if (this.term.length > 2) {
        this.searchResult = [];
        // this.startLoading();
        if (this.isCoordinateSearch()) {
          const coordinateTerm = this.term.trim().replace(/^@/, "");
          const geometry = this.extractCoordinates(coordinateTerm);
          if (geometry) this.addResult([geometry]);
        }
        if (this.term.length > 15) {
          this.searchAddressByText(this.term, storage.getBbox()).then(
            (address) => {
              this.addResult(address);
            }
          );
        }
        this.get(searchEquipmentByName + this.term, null, true).then((data) => {
          this.addResult(data);
          this.isLoading = false
          // this.endLoading();
        });
      } else {
        this.showResults = false;
        this.isLoading = false
      }
    },
    addResult(result) {
      if (this.searchResult.length > 0) {
        this.searchResult = this.searchResult.concat(result);
      } else {
        this.searchResult = result;
      }
    },
    selectAddress(item) {
      this.showResults = false;
      let point;
      if (item.geometry && item.geometry.lat) {
        point = {
          lat: item.geometry.lat(),
          long: item.geometry.lng(),
        };
      } else {
        if (item.condominiumGeometry) {
          point = {
            lat: item.condominiumGeometry.coordinates[1],
            long: item.condominiumGeometry.coordinates[0],
          };
          point.folder = {
            id: item.folderCondominiumId,
            name: item.folderCondominiumName,
            status: item.folderCondominiumStatus,
          };
        } else {
          point = {
            lat: item.geometry.coordinates[1],
            long: item.geometry.coordinates[0],
          };
          if (item.folderId && item.folderName && item.folderStatus)
            point.folder = {
              id: item.folderId,
              name: item.folderName,
              status: item.folderStatus,
            };
        }
      }
      sendMapAction(centerMapPoint, point);
    },
    viability(item) {
      this.showResults = false;
      this.selectAddress(item);
      openSubPopup(6, null, null, {
        address: item.name,
        geometry: item.geometry,
      });
    },
    selectClient(item) {
      this.showResults = false;
      openPopupMap({ type: "S" }, item.geometry, false);
    },
    clear() {
      this.term = "";
      this.clearResult()
    },
    clearResult() {
      this.searchResult = [];
    },
    extractCoordinates(str) {
      const coordinatesRegex = /^(-?\d+(\.\d+)?)$/;
      const [lat, long] = str.split(",").map((coordinate) => {
        const trimmed = coordinate.trim();
        if (coordinatesRegex.test(trimmed)) return parseFloat(trimmed);
      });

      if (lat !== undefined && long !== undefined && lat > -90 && lat < 90 && long > -180 && long < 180) {
        return {
          name: lat + ", " + long,
          geometry: {
            coordinates: [long, lat],
          },
        };
      }
    },
    setHotkeys: (newVal) => {
      store.dispatch("setHotkeys", newVal);
    },
    handleKeyUp(event) {
      if (event.keyCode === 13 || event.keyCode === 40) {
        this.findByText();
      }
    },
    isCoordinateSearch() {
      const value = this.term.trim();
      return /^@?-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(value);
    },
  },
};
</script>

<style scoped>
.search-map {
  position: relative;
  width: 100%;
  z-index: 998;
}

.search-input {
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  color: #333333 !important;
  height: 32px;
}

.search-input::placeholder {
  color: rgba(0, 0, 0, 0.6) !important;
}

.search-input:focus {
  background-color: #ffffff !important;
  border-color: rgba(0, 0, 0, 0.3) !important;
  box-shadow: none !important;
}


.clear-button {
  /* make the clear button visually match the input height and sizing */
  padding: 0 0.35rem;
  height: 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
}

.clear-button:hover {
  color: #020f40 !important;
}

.search-autocomplete {
  position: absolute;
  width: 100%;
  top: 100%;
  margin-top: 4px;
  z-index: 999;
}

.search-autocomplete .card {
  max-height: 250px;
  overflow-y: auto;
  background-color: #ffffff;
  border-radius: 4px;
}

.search-item {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
  cursor: pointer;
  font-size: 0.875rem;
  /* slightly smaller text inside results */
}

.search-item:hover {
  background-color: #f8f9fa;
}

.search-item:last-child {
  border-bottom: none;
}

.action-button {
  padding: 0.25rem 0.5rem;
  background-color: transparent !important;
  border: none !important;
}

.action-button:hover {
  background-color: #f8f9fa !important;
}

.action-button img {
  height: 28px;
  width: 18px;
}

/* ensure small text in the result details is compact */
.search-item small {
  font-size: 0.75rem;
}
</style>